import React from 'react';

interface BodyCellProps extends React.HTMLAttributes<HTMLDivElement> {
  id: string;
}

export const TableBodyCell: React.FC<BodyCellProps> = props => {
  return <div {...props} style={{ ...props.style }} />;
};
